import { Injectable } from '@angular/core';
import * as moment from "moment";
import { StorageService } from '../../providers/storage.service';
import { UserModel } from '../../models/user.model';
import { ChatService } from '../../services/chat.service';
import { AlertService } from '../../providers/alert.service';
import { App } from 'ionic-angular/components/app/app';
import { SigninPage } from '../signin/signin';
import { resolve } from 'path';

@Injectable()
export class ImService {
    subUser: any[];
    constructor(
        private storage: StorageService,
        private chat: ChatService,
        private alert: AlertService,
        private appCtrl: App,
    ) { }
    // 首页获取总消息条数轮询
    public static getMessageCount: any;
    // 聊天页面获取消息轮询
    public static getHistoryList: any;
    //消息列表页面消息轮询
    public static getMessageList: any;
    // 格式化new Date()
    public static time(time = +new Date()) {
        var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
        return date.toJSON().substr(0, 19).replace('T', ' ');
    }
    // 格式化非new Date()
    public static moment(time) {
        time = moment(time, moment.ISO_8601).format("YYYY-MM-DD HH:mm:ss")
        return time
    }
    // 获取上级用户名
    public getParentUserName() {
        return this.storage.read<UserModel>('User').ParentUserName;
    }

    //获取当前用户名
    public getUserName() {
        return this.storage.read<UserModel>('User').UserName
    }

    // 获取聊天记录
    public getFirstHistoryMessage(params, perUser, messages) {
        this.chat.getChatMessage(params).then(s => {
            if (s && s.length > 0) {
                let minID = s[0].Id;
                let maxID = s[s.length - 1].Id;
                this.storage.write('minId', minID);
                this.storage.write('maxId', maxID);
                s.forEach(e => {
                    // 当消息状态为未读且被发送人是当前用户的时候，将消息标记为已读
                    this.setMessageIsRead(e, perUser);
                    e.CreateTime = ImService.moment(e.CreateTime);
                    const historyMessage =
                    {
                        toUserName: e.ToUserName,
                        sendTime: e.CreateTime,
                        text: e.Message,
                    };
                    messages.push(historyMessage);
                });
            }
        }).catch(err => {
            if (err.status === 401 || err.status === 403) {
                this.alert.showAlert("验证已失效，您需要退出重新登录!");
                clearInterval(ImService.getMessageCount);
                clearInterval(ImService.getHistoryList);
                clearInterval(ImService.getMessageList);
                localStorage.clear();
                this.appCtrl.getRootNav().setRoot(SigninPage);
            }
        })
    }

    // 获取最后一条消息记录跟时间

    getLastHistoryMessage(params, messages) {
        // 有时候传过来的params的用户名为空，原因还未调查，先简单处理下
        if (params.toUserName == "" || params.toUserName == null || params.toUserName == undefined) {
            return;
        };
        // 只查一条
        params.pageSize = 1;
        return new Promise(
            (resolve, reject) => {
                this.chat.getChatMessage(params).then(s => {
                    if (s && s.length > 0) {
                        s.forEach(e => {
                            e.CreateTime = ImService.moment(e.CreateTime);
                            const historyMessage = {
                                toUserName: params.toUserName,
                                sendTime: e.CreateTime,
                                text: e.Message,
                            };
                            messages.push(historyMessage);
                        });
                        resolve(messages);
                    }
                }).catch(err => {
                    reject(err);
                    if (err.status === 401 || err.status === 403) {
                        this.alert.showAlert("验证已失效，您需要退出重新登录!");
                        clearInterval(ImService.getMessageCount);
                        clearInterval(ImService.getHistoryList);
                        clearInterval(ImService.getMessageList);
                        localStorage.clear();
                        this.appCtrl.getRootNav().setRoot(SigninPage);
                    }
                })
            }
        );
    }
    // 标记消息为已读
    public setMessageIsRead(e, perUser) {
        if (!e.IsRead && (e.ToUserName == perUser)) {
            this.chat.setChatMessageIsRead(e.Id);
        }
    }

}





// WEBPACK FOOTER //
// ./src/pages/im/im.service.ts